import { Injectable } from '@angular/core';
import { apiEndpoints } from '../constants/api-endpoints';
import { HttpUtilityService } from './http.utility.service';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private readonly httpUtilityService: HttpUtilityService) {}

  downloadFile(fileName: string) {
    const url = `${apiEndpoints.downloadDocument}?fileName=${fileName}`;
    return this.httpUtilityService.getByOptions<any>(url, {
      responseType: 'blob',
      observe: 'response',
    });
  }

  removeBuyersAttachment(payload: any) {
    return this.httpUtilityService.post<any>(
      apiEndpoints.buyerRemoveAttachment,
      payload
    );
  }
}
